import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeAdd = function SvgLargeAdd(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 68 68",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M33.5 8c-3.485 0-6.31 2.76-6.31 6.163V27.72H13.31C9.825 27.72 7 30.48 7 33.884c0 3.404 2.825 6.163 6.31 6.163h13.88v13.558c0 3.403 2.825 6.163 6.31 6.163 3.485 0 6.31-2.76 6.31-6.163V40.047h13.88c3.485 0 6.31-2.76 6.31-6.163 0-3.404-2.825-6.163-6.31-6.163H39.81V14.163C39.81 10.759 36.984 8 33.5 8z"
  }));
};

export default SvgLargeAdd;